import { Snowflake, Flame, Droplets, Wind, Thermometer, Tag, Wrench, FileText } from 'lucide-react';

// ======================= CATEGORIE =======================

export const CATEGORY_LABELS = {
  CLIMATIZZATORE_MONO_SPLIT: 'Clima Mono Split',
  CLIMATIZZATORE_DUAL_SPLIT: 'Clima Dual Split',
  CLIMATIZZATORE_TRIAL_SPLIT: 'Clima Trial Split',
  CALDAIA: 'Caldaia',
  SCALDACQUA: 'Scaldacqua',
  SCALDACQUA_IBRIDO: 'Scaldacqua Ibrido',
  POMPA_DI_CALORE: 'Pompa di Calore',
  TERMOSTATO: 'Termostato',
  ACCESSORIO: 'Accessorio',
  SERVIZIO_INSTALLAZIONE: 'Servizio Installazione',
  SERVIZIO_BUROCRATICO: 'Servizio Burocratico',
  // legacy
  CLIMATIZZATORE_MONO: 'Clima Mono Split',
  CLIMATIZZATORE_DUAL: 'Clima Dual Split',
  CLIMATIZZATORE_TRIAL: 'Clima Trial Split',
  CALDAIA_CONDENSAZIONE: 'Caldaia',
  POMPA_CALORE: 'Pompa di Calore',
};

const climaStyle = { icon: Snowflake, color: 'bg-blue-100 text-blue-700' };
const caldaiaStyle = { icon: Flame, color: 'bg-orange-100 text-orange-700' };
const acquaStyle = { icon: Droplets, color: 'bg-cyan-100 text-cyan-700' };

export const CATEGORY_STYLES = {
  CLIMATIZZATORE_MONO_SPLIT: climaStyle,
  CLIMATIZZATORE_DUAL_SPLIT: climaStyle,
  CLIMATIZZATORE_TRIAL_SPLIT: climaStyle,
  CLIMATIZZATORE_MONO: climaStyle,
  CLIMATIZZATORE_DUAL: climaStyle,
  CLIMATIZZATORE_TRIAL: climaStyle,
  CALDAIA: caldaiaStyle,
  CALDAIA_CONDENSAZIONE: caldaiaStyle,
  SCALDACQUA: acquaStyle,
  SCALDACQUA_IBRIDO: acquaStyle,
  POMPA_DI_CALORE: { icon: Wind, color: 'bg-green-100 text-green-700' },
  POMPA_CALORE: { icon: Wind, color: 'bg-green-100 text-green-700' },
  TERMOSTATO: { icon: Thermometer, color: 'bg-purple-100 text-purple-700' },
  ACCESSORIO: { icon: Tag, color: 'bg-gray-100 text-gray-700' },
  SERVIZIO_INSTALLAZIONE: { icon: Wrench, color: 'bg-slate-100 text-slate-700' },
  SERVIZIO_BUROCRATICO: { icon: FileText, color: 'bg-slate-100 text-slate-700' },
};

// ======================= STATI PRODOTTO =======================

export const PRODUCT_STATUS_CONFIG = {
  ATTIVO: { label: 'Attivo', color: 'bg-green-100 text-green-700 border-green-300' },
  PROMO_ATTIVA: { label: 'Promo Attiva', color: 'bg-blue-100 text-blue-700 border-blue-300' },
  PROMO_SCADUTA: { label: 'Promo Scaduta', color: 'bg-amber-100 text-amber-700 border-amber-300' },
  INATTIVO: { label: 'Inattivo', color: 'bg-gray-100 text-gray-600 border-gray-300' },
  DA_VERIFICARE: { label: 'Da Verificare', color: 'bg-orange-100 text-orange-700 border-orange-300' },
  ARCHIVIATO: { label: 'Archiviato', color: 'bg-red-100 text-red-700 border-red-300' },
};

// ======================= TIPI PROMO =======================

export const PROMO_TYPE_LABELS = {
  SCONTO_IMPORTO: 'Sconto Importo',
  SCONTO_PERCENTUALE: 'Sconto Percentuale',
  PREZZO_PROMO: 'Prezzo Promo',
  VOUCHER: 'Voucher',
  TASSO_ZERO: 'Tasso Zero',
  TERMOSTATO_INCLUSO: 'Termostato Incluso',
  FINDO_IN_BOLLETTA: 'FIDO in Bolletta',
  PROMO_BUNDLE: 'Promo Bundle',
  // legacy
  SCONTO_FISSO: 'Sconto Fisso',
  ACCESSORIO_INCLUSO: 'Accessorio Incluso',
  PREZZO_SPECIALE: 'Prezzo Speciale',
};

// ======================= HELPERS =======================

export const formatPrice = (value, decimals = 0) => {
  if (value === null || value === undefined) return '-';
  return `€ ${Number(value).toLocaleString('it-IT', { minimumFractionDigits: decimals, maximumFractionDigits: 2 })}`;
};

export const formatDateIt = (dateStr) => {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleDateString('it-IT');
  } catch {
    return dateStr;
  }
};

// Prezzo effettivo per il cliente: customer_price > promo_price > base_price
export const getEffectivePrice = (product) => {
  return product.customer_price || product.promo_price || product.base_price;
};
